import { useState } from 'react';
import useModal from 'src/components/Modals/hooks/useModal';
import FeatureAnnouncementBaseModal from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncementBaseModal';
import FeatureAnnouncementBaseLayout from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncementBaseLayout';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { FeatureAnnouncementModalPageConfig } from 'src/components/Modals/FeatureAnnouncementModal/types';
import {
	FEATURE_ANNOUNCEMENT_PREVIEW_IMAGES_PATH,
	FEATURE_ANNOUNCEMENT_S3_BUCKET_PATH,
} from 'src/components/Modals/FeatureAnnouncementModal/consts';

const S3_BUCKET_PATH = `${FEATURE_ANNOUNCEMENT_S3_BUCKET_PATH}/drift-v3`;
const PREVIEW_IMAGE_PATH = `${FEATURE_ANNOUNCEMENT_PREVIEW_IMAGES_PATH}/drift-v3`;

const DRIFT_V3_PAGES_CONFIG: FeatureAnnouncementModalPageConfig[] = [
	{
		title: 'Welcome to Drift v3',
		description:
			'Faster execution, cleaner UI, and the tools you need to trade with confidence. This is the next era of trading on Drift. ',
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/first-page-desktop.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/first-page-desktop.webp`,
		},
		mobileMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/first-page-mobile.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/first-page-mobile.webp`,
		},
	},
	{
		title: 'Meet the Drift v3 UI: A Brand-New Experience',
		description:
			'A sleek new design built for an intuitive, professional trading experience that makes every action faster, clearer, and more efficient.',
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/second-page-desktop-v2.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/second-page-desktop.webp`,
		},
		mobileMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/second-page-mobile-v2.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/second-page-mobile.webp`,
		},
	},
	{
		title: 'New Portfolio Dashboard',
		description:
			'Track your P&L and performance like pro traders. Your entire journey on Drift distilled in one dashboard.',
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/third-page-desktop-v2.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/third-page-desktop.webp`,
		},
		mobileMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/third-page-mobile-v2.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/third-page-mobile.webp`,
		},
	},
	{
		title: 'Reimagined Account Panel',
		description:
			'View your balances across multiple accounts, Vaults, and other Drift products with a single click. You now have more control over your accounts.',
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/fourth-page-desktop-v2.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/fourth-page-desktop.webp`,
		},
		mobileMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/fourth-page-mobile-v2.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/fourth-page-mobile.webp`,
		},
	},
];

export const FeatureAnnouncementDriftV3Modal = () => {
	const { hide } = useModal();
	const isMobileScreenSize = useIsMobileScreenSize();

	const [currentStep, setCurrentStep] = useState(0);

	const currentPageConfig = DRIFT_V3_PAGES_CONFIG[currentStep];

	return (
		<FeatureAnnouncementBaseModal
			announcementName="driftV3"
			title="Drift v3"
			onClose={hide}
			currentStep={currentStep}
			setCurrentStep={setCurrentStep}
			showBackButton={currentStep > 0}
			pagesConfig={DRIFT_V3_PAGES_CONFIG}
		>
			<FeatureAnnouncementBaseLayout
				title={currentPageConfig.title}
				description={currentPageConfig.description}
				media={{
					...(isMobileScreenSize
						? currentPageConfig.mobileMedia
						: currentPageConfig.desktopMedia),
				}}
				mediaLoadingHeight={
					isMobileScreenSize ? 'calc((100vw - 32px) * 0.864)' : 338.2
				}
				step={currentStep}
				totalSteps={DRIFT_V3_PAGES_CONFIG.length}
			/>
		</FeatureAnnouncementBaseModal>
	);
};
